import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { KpiBranchAssignmentBodyModel } from '@/types'

export const postKpiBranchAssignments = async (
  assignments: KpiBranchAssignmentBodyModel[]
): Promise<void> => {
  try {
    await axios.post(`${BASE_URL}/kpi/branch-assignments/`, assignments)
  } catch (error) {
    console.error('Error posting KPI branch assignments:', error)
    throw error
  }
}
